
import Vue from "vue";
export default Vue.extend({
	methods: {
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.pdf-archive"
	}
});
